import { api } from "~/utils/api"

export function useAllocationInTransitMap() {
  return api.allocation.getAllocationInTransitMap.useQuery()
}
